import { SmsSubmitModel } from "../modelos/sms/SmsSubmitModel";

export const INIT_SMS_FORM_DATA: SmsSubmitModel = {
    mensagem: "",
    idsPassageiros: [],
  };